



















import { Component, Vue } from 'vue-property-decorator';
import LatelyMessage from '@/components/dashboard/latelyMessage.vue';
import LatelyChat from '@/components/dashboard/latelyChat.vue';
import LatelyReport from '@/components/dashboard/latelyReport.vue';
import { Account } from '@/modules/me';
import { FunctionTypes } from '@/enums/functionTypes';
import { UserTypes } from '@/enums/userTypes';

@Component({
  components: {
    'lately-message': LatelyMessage,
    'lately-chat': LatelyChat,
    'lately-report': LatelyReport
  }
})
export default class Top extends Vue {
  private FunctionTypes = FunctionTypes;
  private UserTypes = UserTypes;

  get user(): Account {
    return this.$store.state.me.user;
  }

  get userName(): string {
    if (!this.user) {
      return '';
    } else {
      return `${this.user.lastName}　${this.user.firstName}`;
    }
  }

  get pageTitle(): string {
    return `
      <div>
        <span style="font-size:x-large; font-weight:bold;">${this.userName}</span>
        <span style="font-size:medium; margin-left:10px;">さんのページ</span>
      </div>`;
  }

   get availableFunction(): number {
    if (!this.user) {
      return 0;
    }
    return this.user.availableFunctionbit;
  }

  get userRole(): UserTypes {
    return this.$store.getters['auth/userType'];
  }

  private created() {
    // 生徒アカウントで遷移してきた場合強制でスケジュール画面へ
    if (this.userRole === UserTypes.Student) {
      this.$router.push({
        name: 'StudentCalendar',
        params: {
          studentId: this.$store.getters['auth/accountId'],
        }
    });
    }
  }

  private deactivated() {
    this.$destroy();
  }
}
